import { render, staticRenderFns } from "./taskData.vue?vue&type=template&id=208c20b6&scoped=true&"
import script from "./taskData.vue?vue&type=script&lang=js&"
export * from "./taskData.vue?vue&type=script&lang=js&"
import style0 from "./taskData.vue?vue&type=style&index=0&id=208c20b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c20b6",
  null
  
)

export default component.exports